import { push as pushAction } from 'react-router-redux';

export function push(args) {
  return pushAction(args);
}
